import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

export default function TermsConditions() {
  return (
    <div className="min-h-screen bg-[#F9F8F6] pt-24 pb-12 px-4">
      <Card className="max-w-4xl mx-auto border-0 shadow-xl">
        <CardHeader>
          <CardTitle className="text-3xl font-bold text-[#1A3636]">Términos y Condiciones</CardTitle>
          <p className="text-gray-500">Última actualización: Marzo 2026</p>
        </CardHeader>
        <CardContent className="prose prose-gray max-w-none space-y-6 text-[#333]">
          <section>
            <h2 className="text-xl font-bold text-[#1A3636]">1. Descripción del Servicio</h2>
            <p>SOS FindMed es un servicio de membresía prepagada que brinda acceso a servicios de ambulancia de emergencia. Al adquirir una membresía, el usuario obtiene el derecho a solicitar una unidad de ambulancia en caso de emergencia médica durante la vigencia de su membresía.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1A3636]">2. Membresía</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>La membresía tiene un costo de $899.00 MXN (Ochocientos noventa y nueve pesos mexicanos) anuales.</li>
              <li>La membresía es personal e intransferible.</li>
              <li>La membresía se activa 72 horas después de completar el registro y activación.</li>
              <li>La vigencia de la membresía es de un año a partir de la fecha de activación.</li>
              <li>Cada membresía permite el uso del servicio de ambulancia una sola vez.</li>
              <li>En caso de menores de edad, un tutor o padre deberá realizar el registro proporcionando su identificación oficial (INE).</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1A3636]">3. Renovación</h2>
            <p>Si el usuario eligió la opción de renovación automática, el cargo se realizará automáticamente a la tarjeta registrada al cumplirse un año desde la activación. El usuario puede cancelar la renovación automática en cualquier momento desde su panel de usuario o contactando a nuestro equipo de soporte.</p>
            <p>Si el usuario no eligió renovación automática, deberá adquirir una nueva membresía al vencimiento de la actual.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1A3636]">4. Uso del Servicio</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>El servicio de ambulancia está destinado exclusivamente para emergencias médicas reales.</li>
              <li>El uso indebido del servicio (falsas emergencias) resultará en la cancelación inmediata de la membresía sin derecho a reembolso.</li>
              <li>Una vez utilizado el servicio, la membresía se considera consumida.</li>
              <li>El tiempo de respuesta puede variar según la ubicación y disponibilidad de unidades.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1A3636]">5. Definición de Emergencia, Urgencia y Eventos No Cubiertos</h2>
            <p className="text-sm text-gray-600 italic mb-4">Con el propósito de dar claridad al usuario respecto del alcance del servicio contratado, SOS FindMed establece las siguientes definiciones operativas, mismas que servirán como criterio de referencia para la evaluación de solicitudes de atención, orientación o traslado:</p>
            
            <h3 className="text-lg font-bold text-[#C81D25] mt-6">A. Emergencia Médica</h3>
            <p>Se entenderá por emergencia médica toda condición súbita, imprevista o derivada de accidente o padecimiento agudo que comprometa de manera inmediata la vida del usuario, la funcionalidad de un órgano, sistema o extremidad, o que implique un riesgo serio de deterioro grave si no se brinda atención prehospitalaria y/o traslado asistido de forma inmediata.</p>
            <p className="font-medium mt-2">De manera enunciativa mas no limitativa, podrán considerarse como emergencia médica los siguientes supuestos:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Pérdida del estado de conciencia o inconsciencia</li>
              <li>Dificultad respiratoria severa o ausencia de respiración</li>
              <li>Dolor torácico intenso con sospecha de evento cardiovascular agudo</li>
              <li>Convulsiones</li>
              <li>Sangrado abundante o hemorragia activa</li>
              <li>Sospecha de evento vascular cerebral</li>
              <li>Traumatismos severos</li>
              <li>Caídas de altura</li>
              <li>Atropellamientos</li>
              <li>Accidentes automovilísticos de consideración</li>
              <li>Quemaduras de gravedad</li>
              <li>Reacciones alérgicas severas</li>
              <li>Intoxicaciones agudas</li>
              <li>Fracturas expuestas</li>
              <li>Lesiones con deformidad evidente, incapacidad funcional severa o dolor incapacitante posterior a un evento traumático</li>
              <li>Cualquier otra condición que, bajo criterio razonable de valoración inicial, represente un peligro real e inmediato para la vida o integridad del usuario</li>
            </ul>

            <h3 className="text-lg font-bold text-[#C81D25] mt-6">B. Urgencia Médica</h3>
            <p>Se entenderá por urgencia médica toda alteración del estado de salud que requiere atención médica pronta, pero que, al momento de la solicitud, no presenta datos evidentes de riesgo vital inminente.</p>
            <p className="font-medium mt-2">De manera enunciativa mas no limitativa, podrán considerarse como urgencia médica los siguientes supuestos:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Fiebre alta con deterioro importante del estado general</li>
              <li>Dolor agudo o progresivo de intensidad considerable</li>
              <li>Sospecha de fractura cerrada</li>
              <li>Luxaciones</li>
              <li>Lesiones dolorosas con limitación funcional importante</li>
              <li>Vómito o diarrea persistente con signos de deshidratación</li>
              <li>Dolor abdominal intenso</li>
              <li>Crisis asmática moderada</li>
              <li>Caídas con dolor importante e incapacidad para la movilización habitual</li>
              <li>Cualquier otro padecimiento agudo que requiera valoración pronta y que, sin constituir una amenaza inmediata para la vida, amerite atención médica prioritaria</li>
            </ul>

            <h3 className="text-lg font-bold text-[#C81D25] mt-6">C. Eventos que No Constituyen Emergencia ni Urgencia Médica</h3>
            <p>No se considerarán, para efectos de la naturaleza del servicio, como emergencia ni urgencia médica inmediata, aquellos eventos o padecimientos que no impliquen riesgo vital inminente, deterioro agudo relevante ni necesidad objetiva de atención prehospitalaria inmediata.</p>
            <p className="font-medium mt-2">De manera enunciativa mas no limitativa, se considerarán dentro de esta categoría:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Consultas médicas programadas</li>
              <li>Estudios diagnósticos agendados</li>
              <li>Traslados por comodidad, conveniencia o preferencia personal</li>
              <li>Valoraciones de rutina</li>
              <li>Malestares leves o crónicos sin exacerbación aguda</li>
              <li>Síntomas respiratorios leves sin dificultad respiratoria</li>
              <li>Lesiones menores que no comprometan movilidad funcional de forma importante</li>
              <li>Dolores leves o moderados sin datos de alarma</li>
              <li>Cualquier solicitud de traslado que no derive de una condición médica aguda que amerite atención prehospitalaria o movilización asistida inmediata</li>
            </ul>

            <h3 className="text-lg font-bold text-[#C81D25] mt-6">D. Criterio de Evaluación del Servicio</h3>
            <p>El usuario reconoce y acepta que la clasificación del evento reportado como emergencia, urgencia o evento no urgente podrá realizarse con base en la información proporcionada al momento de solicitar el servicio, así como en criterios operativos y de valoración inicial aplicables a la atención prehospitalaria.</p>
            <p className="mt-2">La procedencia del servicio estará sujeta a:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>La naturaleza del evento reportado</li>
              <li>La disponibilidad operativa</li>
              <li>La zona de cobertura</li>
              <li>Los lineamientos vigentes del producto contratado</li>
            </ul>

            <h3 className="text-lg font-bold text-[#C81D25] mt-6">E. Exclusiones por Naturaleza del Evento</h3>
            <p>El usuario reconoce y acepta que SOS FindMed no está diseñado para sustituir:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Consultas médicas de rutina</li>
              <li>Traslados programados</li>
              <li>Servicios de acompañamiento no urgente</li>
              <li>Movilizaciones solicitadas únicamente por comodidad o conveniencia personal</li>
            </ul>
            <p className="mt-2">En consecuencia, el servicio podrá no proceder cuando la solicitud corresponda a eventos que, por su naturaleza, no sean razonablemente clasificables como urgencia o emergencia médica.</p>

            <h3 className="text-lg font-bold text-[#C81D25] mt-6">F. Alcance Informativo</h3>
            <p>Las presentes definiciones tienen carácter informativo, preventivo y operativo, y buscan orientar al usuario respecto del uso adecuado del servicio, evitando interpretaciones erróneas sobre su alcance.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1A3636]">6. Identificación Oficial</h2>
            <p>Para activar la membresía, el usuario deberá proporcionar una copia de su identificación oficial (INE) vigente. Esta información se utiliza exclusivamente para verificar la identidad del titular y se maneja conforme a nuestro Aviso de Privacidad.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1A3636]">7. Pagos y Reembolsos</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Los pagos se procesan de forma segura a través de Stripe.</li>
              <li>No se realizarán reembolsos una vez activada la membresía.</li>
              <li>En caso de que la membresía no haya sido activada, el usuario podrá solicitar un reembolso dentro de los primeros 7 días posteriores a la compra.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1A3636]">8. Limitaciones de Responsabilidad</h2>
            <p>SOS FindMed se compromete a brindar el servicio de la mejor manera posible, sin embargo, no se hace responsable por retrasos causados por condiciones climáticas adversas, tráfico vehicular extremo, desastres naturales u otras circunstancias de fuerza mayor.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1A3636]">9. Contacto</h2>
            <p>Para cualquier duda o aclaración sobre estos términos, puede contactarnos:</p>
            <ul className="list-disc pl-6">
              <li>Teléfono de emergencias: 55 2567 1884</li>
              <li>Email: contacto@findmed.com.mx</li>
            </ul>
          </section>
        </CardContent>
      </Card>
    </div>
  );
}
